// @ts-nocheck

export const CELL = 160;
export const HOLE_W = 50;
export const TOMBSTONE_W = 55;
export const TOMBSTONE_H = 70;
/**
 * Minimum world Y for generated/placed memorials. A tombstone is centred on
 * its hole and is ~116px tall, so its top sits at worldY ≈ holeY − 58. Must
 * match the backend constant in pethernity_be/src/lib/headstone-coords.ts.
 */
export const MIN_VISIBLE_WORLD_Y = 110;
/** Minimum center-to-center distance between holes/tombstones (px).
 * Must exceed the rendered "glass dome" footprint (~104×116px, see
 * molecules/tombstone.css) so memorials never overlap. Mirrored in the backend
 * pethernity_be/src/lib/headstone-coords.ts. */
export const MIN_HOLE_SEPARATION = 135;
/** Max procedural jitter per axis: (CELL - MIN_HOLE_SEPARATION) / 2 */
export const HOLE_JITTER = 32;
export const TEMPLE_R = 300;
export const CHUNK = 5;
export const BUCKET_SZ = 200;
export const DECOR_BUCKET = 150;

/** Matches organisms/viewport.css and floating-buttons.css mobile breakpoint. */
export const MOBILE_BREAKPOINT = 768;
/** Panoramic zoom on mobile: slightly wider than desktop so more tombs fit per row. */
export const MOBILE_INITIAL_ZOOM = 0.45;

// Zoom iniziale: vista panoramica "dall'alto" del tempio e delle tombe circostanti
export const INITIAL_ZOOM = 0.55;
/** Tre livelli: panoramica → zoom in → zoom in maggiore → reset al click successivo */
export const ZOOM_LEVELS = [INITIAL_ZOOM, 0.9, 1.2] as const;
export const MAX_ZOOM_STEP = ZOOM_LEVELS.length - 1;
export const MAX_ZOOM = ZOOM_LEVELS[MAX_ZOOM_STEP];
